"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const modal_component_1 = require("../../../commonUi/src/modal/modal.component");
const IUserAuthStateService_interface_1 = require("../interfaces/IUserAuthStateService.interface");
let UserLoginComponent = class UserLoginComponent {
    constructor(_userAuthStateService, _ngZone, _renderer) {
        this._userAuthStateService = _userAuthStateService;
        this._ngZone = _ngZone;
        this._renderer = _renderer;
        this._actions = new Array();
    }
    ngOnInit() {
        this.username = this._userAuthStateService.username;
        this.password = "";
        this._userAuthStateService.actionRequest().subscribe((action) => {
            if (action.name === "login") {
                this._actions.push(action);
                if (!this.modal.visible) {
                    this.show();
                }
            }
        });
    }
    show() {
        this.username = this._userAuthStateService.username;
        this.password = "";
        this.modal.show();
        this._ngZone.runOutsideAngular(() => {
            setTimeout(() => this.focusInputUsername(), 0);
        });
    }
    handleKeyUp(event) {
        if (event.keyCode === 13) {
            if (event.srcElement.id === "username") {
                this.focusInputPassword();
                event.preventDefault();
            }
            else if (event.srcElement.id === "pwd") {
                this.submit();
            }
        }
        else if (event.keyCode === 27) {
            this.cancel();
        }
    }
    handleKeyDown(event) {
        if (event.keyCode === 9) {
            if (event.shiftKey) {
                if (event.srcElement.id === "username") {
                    this.focus(this.buttonSubmitElementRef);
                    event.preventDefault();
                }
            }
            else {
                if (event.srcElement.id === "submit") {
                    this.focusInputUsername();
                    event.preventDefault();
                }
            }
        }
    }
    submit() {
        this._actions.forEach(a => {
            let level = a.service.authenticate(this.username, this.password);
            if (level !== "") {
                a.authResult(this.username, level, true);
            }
            else {
                a.authResult("", "", false);
            }
        });
        this.modal.hide();
    }
    cancel() {
        this._actions.forEach(a => a.authResult("", "", false));
        this.modal.hide();
    }
    focusInputUsername() {
        this._renderer.invokeElementMethod(this.inputUsernameElementRef.nativeElement, 'focus', []);
    }
    focusInputPassword() {
        this._renderer.invokeElementMethod(this.inputPasswordElementRef.nativeElement, 'focus', []);
    }
    focusButtonSubmit() {
        this.focus(this.buttonSubmitElementRef);
    }
    focus(el) {
        this._renderer.invokeElementMethod(el.nativeElement, 'focus', []);
    }
};
__decorate([
    core_1.ViewChild('inputUsername'),
    __metadata("design:type", core_1.ElementRef)
], UserLoginComponent.prototype, "inputUsernameElementRef", void 0);
__decorate([
    core_1.ViewChild('inputPassword'),
    __metadata("design:type", core_1.ElementRef)
], UserLoginComponent.prototype, "inputPasswordElementRef", void 0);
__decorate([
    core_1.ViewChild('buttonSubmit'),
    __metadata("design:type", core_1.ElementRef)
], UserLoginComponent.prototype, "buttonSubmitElementRef", void 0);
__decorate([
    core_1.ViewChild(modal_component_1.ModalComponent),
    __metadata("design:type", modal_component_1.ModalComponent)
], UserLoginComponent.prototype, "modal", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], UserLoginComponent.prototype, "username", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], UserLoginComponent.prototype, "password", void 0);
UserLoginComponent = __decorate([
    core_1.Component({
        selector: 'user-login',
        template: `
    <app-modal>
        <div class="app-modal-header">
          <h4 class="modal-title">{{ 'login.login' | translate }}</h4>
        </div>
        <div class="app-modal-body">
          <form>
            <div class="form-group">
              <label for="username">{{ 'login.username' | translate }}</label>
              <input #inputUsername class="form-control" id="username" [(ngModel)]="username" name="username" (keydown)="handleKeyDown($event)" (keyup)="handleKeyUp($event)">
            </div>
            <div class="form-group">
              <label for="pwd">{{ 'login.password' | translate }}</label>
              <input #inputPassword type="password" class="form-control" id="pwd" [(ngModel)]="password" name="password" (keyup)="handleKeyUp($event)">
            </div>
          </form>
        </div>
        <div class="app-modal-footer">
          <button type="button" class="btn btn-default" (click)="cancel()">{{ 'login.cancel' | translate}}</button>
          <button #buttonSubmit id="submit" type="button" class="btn btn-primary" (click)="submit()" (keydown)="handleKeyDown($event)">{{ 'login.submit' | translate}}</button>
        </div>
    </app-modal>
  `
    }),
    __param(0, core_1.Inject(IUserAuthStateService_interface_1.IUSERAUTHSTATESERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object, core_1.NgZone, core_1.Renderer])
], UserLoginComponent);
exports.UserLoginComponent = UserLoginComponent;
